//@flow
import withHandledAgentData from "./withHandledAgentData";
import AgentCard from "./AgentCard";

const ConnectedAgentCard = withHandledAgentData(AgentCard);
export default ConnectedAgentCard;